<template>
    <div v-if="isLoading">
        <b-row>
            <b-col md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-5"
                />
            </b-col>
        </b-row>
    </div>

    <div v-else class="animated fadeIn pt-1">
        <b-row>
            <b-col md="12">
                <component-header
                    title="Features"
                    :hasSearch="true"
                    :hasReload="true"
                    :isLoading="isLoading"
                    @reload-data="fetchFeatureList"
                    createButtonText="Add Feature"
                    @search-query="(val) => (filter = val)"
                    @create-press="onClickAddFeature"
                    :hasback="false"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col md="12">
                <b-card border-variant="info" class="card-wrap shadow-sm">
                    <div class="table-wrapper">
                        <b-table
                            id="features-table"
                            responsive
                            hover
                            bordered
                            head-variant="light"
                            :items="tableData"
                            :fields="tableFields"
                            :current-page="currentPage"
                            :per-page="perPage"
                            thead-class="header"
                            show-empty
                            :filter="filter"
                            :busy="isLoading"
                            @filtered="onFilter"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            class="custom-table mb-0"
                        >
                            <template #empty>
                                <div v-if="isLoading" class="text-center py-3">
                                    <b-spinner
                                        small
                                        type="grow"
                                        variant="info"
                                    ></b-spinner>
                                    <b class="ml-2">Loading...</b>
                                </div>
                                <div v-else class="text-center py-3 text-muted">
                                    No data available.
                                </div>
                            </template>

                            <!-- Action Buttons -->
                            <template #cell(Action)="data">
                                <div class="action-buttons">
                                    <b-button
                                        size="sm"
                                        class="button-circle"
                                        variant="primary"
                                        @click="onClickView(data.item)"
                                    >
                                        <i class="fa fa-eye"></i>
                                    </b-button>
                                    <b-button
                                        size="sm"
                                        class="button-circle btn-warning color-white"
                                        @click="onClickEdit(data.item)"
                                    >
                                        <i class="fa fa-pencil"></i>
                                    </b-button>
                                    <b-button
                                        size="sm"
                                        class="button-circle"
                                        variant="danger"
                                        @click="deleteFeature(data.item)"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </b-button>
                                </div>
                            </template>

                        </b-table>
                    </div>
                    <div class="pagination-wrapper">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="perPage"
                            :total-rows="totalRows"
                            aria-controls="features-table"
                            prev-text="Prev"
                            next-text="Next"
                            hide-goto-end-buttons
                        ></b-pagination>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";

export default {
    name: "features",
    components: {
        ComponentHeader,
        AtomSpinner,
    },
    data() {
        return {
            isLoading: false,
            filterCount: null,
            filter: "",
            sortBy: "createdAt",
            sortDesc: true,
            currentPage: 1,
            perPage: 10,
            tableFields: [
                { label: "Feature Name", key: "name" },
                {
                    label: "Description",
                    key: "description",
                    formatter: "shortDescription",
                    class: "textAlignment",
                },
                                {
                                    label: "Permission",
                                    key: "permission",
                                    formatter: "NoOfPermissions",
                                    thClass: "text-center",
                                    tdClass: "text-center",
                                },
                {
                    label: "Action",
                    key: "Action",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
            ],
        };
    },
    computed: {
        ...mapGetters({
            allFeatureList: "feature/GetFeatureList",
        }),
        tableData() {
            return this.allFeatureList || [];
        },
        totalRows() {
            return this.filterCount !== null ? this.filterCount : this.tableData.length;
        },
    },
    watch: {
        tableData: {
            handler(newVal) {
                if (this.filterCount === null && newVal && newVal.length > 0) {
                    this.filterCount = newVal.length;
                }
            },
            immediate: true,
        },
    },
    methods: {
        shortDescription(value) {
            if (!value) return "";
            return value.length > 210 ? value.slice(0, 210) + "..." : value;
        },
        async fetchFeatureList() {
            this.isLoading = true;
            try {
                await this.$store.dispatch("feature/fetchFeatureList");
            } finally {
                this.isLoading = false;
            }
        },
        onFilter(list) {
            this.filterCount = list ? list.length : 0;
            this.currentPage = 1;
        },
        onClickAddFeature() {
            this.$router.push({ path: "/features/addFeature" });
        },
        onClickEdit(data) {
            this.$router.push({
                name: "edit-feature",
                params: { id: data._id },
            });
        },
        onClickView(data) {
            this.$router.push({
                name: "view-feature",
                params: { id: data._id },
            });
        },
        NoOfPermissions(value) {
            return Array.isArray(value) ? value.length : 0;
        },
        async deleteFeature(data) {
            const result = await this.$swal({
                title: "Are you sure?",
                text: "You can't revert this action!!",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            });
            if (result.value) {
                this.isLoading = true;
                try {
                    await this.$store.dispatch("feature/deleteFeature", data._id);
                    this.$toasted.success("Feature Deleted Successfully");
                    await this.$store.dispatch("feature/fetchFeatureList");
                } catch (error) {
                    this.$toasted.error((error && error.message) || "Delete failed");
                } finally {
                    this.isLoading = false;
                }
            }
        },
    },
    async mounted() {
        this.fetchFeatureList();
    },
};
</script>

<style scoped>
.card-wrap {
    border-radius: 12px;
}

.pagination-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
}

.btn-warning {
    background: #fe7b08 !important;
    border-color: #fe7b08 !important;
    color: white !important;
}

.table-wrapper {
    overflow-x: auto;
}

tbody tr:nth-child(2n + 1) {
    border-bottom: 1px solid #e8e5e5;
}

td.textAlignment {
    text-align: justify !important;
    white-space: pre-wrap;
}

.custom-table {
    width: 100%;
    table-layout: fixed;
    border-collapse: separate !important;
    border-spacing: 0;
}

.custom-table th,
.custom-table td {
    vertical-align: middle !important;
    word-wrap: break-word;
    white-space: normal;
    padding: 10px;
    border-right: 1px solid #e8e5e5;
}

.custom-table th:nth-child(1),
.custom-table td:nth-child(1) {
    min-width: 180px;
    text-align: left;
}

.custom-table th:nth-child(2),
.custom-table td:nth-child(2) {
    min-width: 300px;
    text-align: left;
}

.custom-table th:nth-child(3),
.custom-table td:nth-child(3) {
    min-width: 120px;
    text-align: center;
}

.custom-table th:nth-child(4),
.custom-table td:nth-child(4) {
    min-width: 150px;
    text-align: center;
}


.action-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
}

.action-buttons .button-circle {
    flex-shrink: 0;
}

@media (max-width: 768px) {
    .pagination-wrapper {
        justify-content: center;
    }

    .custom-table th:nth-child(2),
    .custom-table td:nth-child(2) {
        min-width: 200px;
    }
}
</style>